var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.terms)?_c('div',{staticClass:"mb-3 justify-content-center w-100"},[_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.terms)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }